import { Facebook, Instagram } from 'lucide-react';
import './SocialLinks.css';

export const SocialLinks = () => (
  <nav className="footer-social-links" aria-label="Social media">
    <a href="https://www.facebook.com/thehomelibraryproject" target="_blank" rel="noopener noreferrer" aria-label="The Home Library Project on Facebook (opens in a new tab)">
      <Facebook size={22} aria-hidden="true" />
    </a>
    <a href="https://www.instagram.com/thehomelibraryproject" target="_blank" rel="noopener noreferrer" aria-label="The Home Library Project on Instagram (opens in a new tab)">
      <Instagram size={22} aria-hidden="true" />
    </a>
  </nav>
);
